import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { OneStepLink} from 'models';

@Injectable({
    providedIn: 'root'
})

export class OneStepService {
    constructor(private http: HttpClient) {}

    public get(identifier: string): Observable<OneStepLink> {
        return this.http.get<OneStepLink>(`api/onestep/by-identifier/${identifier}`);
    }

    public getByUser(): Observable<string> {
        return this.http.get<string>(`api/onestep/by-user`);
    }
}
